// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-category-card svg.new-category-card-close-btn path {
    stroke: #E65B65;
}

.new-category-card svg.new-category-card-close-btn {
    width: 32px !important;
    height: 32px !important;
}

.card-close-btn {
    padding: 0 !important;
}

.search-input-icon {
    width: 30px !important;
    height: 30px !important;
}

/* make here min width 768 to appy only desktop device*/
.new-category-card {
    padding-top: 12px !important;
}

.category-card {
    padding: 10px 14px !important;
}

.category-list-section {
    padding: 22px 25px !important;
}

.product-card {
    padding: 15px 15px !important;
}

.product-details-image-section {
    border-radius: 8px !important;
}

.action-buttons {
    margin-top: 0px !important;
}

.product-image-section {
    border-radius: 4px !important;
}

/* make here min width 768 to appy only desktop device*/


@media (max-width: 768px) {
    .category-list-section {
        padding: 15px 20px !important;
    }

    .product-card {
        padding: 10px 12px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Merchant/Catalog/catlog.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,uDAAuD;AACvD;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,uDAAuD;;;AAGvD;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".new-category-card svg.new-category-card-close-btn path {\r\n    stroke: #E65B65;\r\n}\r\n\r\n.new-category-card svg.new-category-card-close-btn {\r\n    width: 32px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.card-close-btn {\r\n    padding: 0 !important;\r\n}\r\n\r\n.search-input-icon {\r\n    width: 30px !important;\r\n    height: 30px !important;\r\n}\r\n\r\n/* make here min width 768 to appy only desktop device*/\r\n.new-category-card {\r\n    padding-top: 12px !important;\r\n}\r\n\r\n.category-card {\r\n    padding: 10px 14px !important;\r\n}\r\n\r\n.category-list-section {\r\n    padding: 22px 25px !important;\r\n}\r\n\r\n.product-card {\r\n    padding: 15px 15px !important;\r\n}\r\n\r\n.product-details-image-section {\r\n    border-radius: 8px !important;\r\n}\r\n\r\n.action-buttons {\r\n    margin-top: 0px !important;\r\n}\r\n\r\n.product-image-section {\r\n    border-radius: 4px !important;\r\n}\r\n\r\n/* make here min width 768 to appy only desktop device*/\r\n\r\n\r\n@media (max-width: 768px) {\r\n    .category-list-section {\r\n        padding: 15px 20px !important;\r\n    }\r\n\r\n    .product-card {\r\n        padding: 10px 12px !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
